












































import {Component, Vue, Watch, Ref} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import { Toast } from 'buefy/dist/components/toast';
import { Snackbar } from 'buefy/dist/components/snackbar';
import Navbar from '@/components/SignUp/Navbar.vue';
import {Action, State} from 'vuex-class'; // @ is an alias to /src
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types'; // @ is an alias to /src
import InfoModal from '../components/Home/InfoModal.vue';
import BModal from 'buefy/src/components/modal/Modal.vue';
import ModalTemplate from '@/components/common/ModalTemplate.vue';
import InfoModalFooter from '@/components/Home/InfoModalFooter.vue';
import {modalTemplate} from '@/components/common/types';

@Component({
  components: {
    InfoModalFooter,
    ModalTemplate,
    Navbar, BButton, BInput, BField, InfoModal, BModal,
  },
})
export default class Home extends Vue {
  @Action('CreateUser') public CreateUser: any;
  @State('self', {namespace: 'userState'}) public self: MAFUser | undefined;
  @Ref('infoModal') public infoModal!: modalTemplate;
  @Action('confirmEmail') public confirmEmail: any;

  public showSignIn: boolean;
  public email: string;
  public emailMessage: string;
  public password: string;
  public passwordMessage: string;
  public isLoading: boolean;
  public showInfoModal: boolean;
  public attemptedLogin: boolean = false;
  public showEmailSent: boolean = false;
  public newuser: any = null;
  constructor() {
    super();
    this.showSignIn = true;
    this.email = '';
    this.password = '';
    this.isLoading = false;
    this.emailMessage = 'An email is required.';
    this.passwordMessage = 'A password is required.';
    this.showInfoModal = false;
  }

  public async login(event: any) {
    event.preventDefault();
    this.attemptedLogin = true;
    this.isLoading = true;

    try {
      this.showEmailSent = false;
      await this.CreateUser({email: this.email, password: this.password});
      this.checkEmail();
    } catch (error) {
      this.$snackbar.open({
        duration: 5000,
        message: `${error} or has been deleted.`,
        type: 'is-danger',
        position: 'is-bottom-left',
        indefinite: true,
        // onAction: () => {
        //   if (`${error}` === 'Error: The email address is already in use by another account.') {
        //     this.$router.push('signin');
        //   }
        // },
      });

      setTimeout(() => {
        if (`${error}` === 'Error: The email address is already in use by another account.') {
          this.$router.push('signin');
        }
      }, 5000);
    }

    this.isLoading = false;
    return false;
  }

  public async showModal() {
    this.showInfoModal = true;
  }

  public closeModal() {
    this.infoModal.close();
  }

  /* tslint:disable:no-console */
  public checkEmail() {
    try {
      this.newuser = Vue.prototype.$auth.currentUser;
      this.newuser.sendEmailVerification();
      this.showEmailSent = true;
    } catch (e) {
      console.error('Error sending email');
    }
  }
}
